(function () {
  'use strict';

  var AR = /^ar\b/i.test(document.documentElement.lang || '') ||
    document.documentElement.dir === 'rtl';

  var IMAGE_URLS = Object.freeze({
    internal_engine_part: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-internal-engine-part.png?v=1787656939',
    engine_mount: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-engine-mount.png?v=1787656725',
    spark_plug: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-spark-plug.png?v=1787656903',
    engine_belt: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-engine-belt.jpg?v=1787656891',
    water_pump: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-water-pump.png?v=1787657018',
    radiator: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-cooling.png?v=1787656894',
    fuel_injector: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-fuel-injector.png?v=1787657157',
    oxygen_sensor: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-oxygen-sensor.png?v=1787657114',
    front_brake_pad: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-front-brake-pad.png?v=1787656949',
    brake_rotor: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-brake-rotor.png?v=1787657004',
    shock_absorber: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-shock-absorber.png?v=1787657078',
    control_arm: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-control-arm.png?v=1787657087',
    sway_bar_link: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-sway-bar-link.jpg?v=1787657095',
    bearing: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-bearing.png?v=1787657098',
    steering_part: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-steering-part.png?v=1787657106',
    cv_joint: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-cv-joint.png?v=1787657227',
    transmission_part: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-transmission-part.png?v=1787657244',
    ac_compressor: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac.png?v=1787656899',
    alternator: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-electrical-parts.png?v=1787656933',
    exhaust_part: 'https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-exhaust.png?v=1787656736'
  });

  var FALLBACK_PATTERNS = Object.freeze({
    engine: /(?:internal engine|piston|connecting rod|oil pump|valve train|بستم|ذراع توصيل|طرمبة زيت|قطع داخلية)/i,
    mounts: /(?:engine mount|transmission mount|motor mount|كرسي مكينة|كرسي جير|قاعدة محرك|قاعدة جير)/i,
    ignition: /(?:spark plug|ignition coil|ignition part|بواجي|بوجي|كويل|اشعال|إشعال)/i,
    belts_timing: /(?:engine belt|belt tensioner|pulley|timing belt|timing chain|timing guide|timing sprocket|سير|شداد|بكرة|تايمن)/i,
    water_thermostat: /(?:water pump|thermostat|واتر بمب|طرمبة ماء|ثرموستات)/i,
    radiator_hoses: /(?:radiator|cooling hose|radiator cap|راديتر|رديتر|هوز|خرطوم تبريد|غطاء راديتر)/i,
    fuel_injection: /(?:fuel pump|fuel injector|throttle body|intake manifold|air intake|طرمبة وقود|مضخة وقود|بخاخ|ثروتل|منيفولد|مانيفولد)/i,
    engine_sensors: /(?:oxygen sensor|knock sensor|camshaft sensor|crankshaft sensor|maf sensor|حساس اكسجين|حساس أكسجين|حساس طرق|حساس كام|حساس كرنك|حساس هواء)/i,
    brake_pads: /(?:front brake pad|rear brake pad|brake hardware|سفايف|فحمات فرامل|ملحقات سفايف)/i,
    brake_parts: /(?:brake rotor|brake disc|brake part|abs sensor|ديسك فرامل|هوب فرامل|حساس abs|قطع فرامل)/i,
    shocks: /(?:shock absorber|suspension part|strut|مساعد|جامبين|قطعة تعليق)/i,
    arms_bushings: /(?:control arm|bushing|مقص|جلب|جلدة مقص)/i,
    links_joints: /(?:sway bar link|ball joint|stabilizer link|رابط ميزان|وصلة ميزان|مفصل كروي)/i,
    bearings_hubs: /(?:wheel bearing|wheel hub|bearing|رمان|رولمان|هوب عجلة)/i,
    steering: /(?:steering part|suspension arm|tie rod|rack end|دركسون|ذراع تعليق|تي رود)/i,
    drivetrain: /(?:cv joint|cv axle|driveshaft|universal joint|drivetrain|عكس|رأس عكس|درايف شافت|عمود دوران|صليبة)/i,
    transmission_diff: /(?:transmission part|transmission filter|transmission gasket|differential|gearbox|جير|قير|دفرنس|فلتر جير|جازكيت جير)/i,
    ac: /(?:ac compressor|air conditioning|evaporator|condenser|ac valve|ac sensor|كمبروسر|كمبريسر|مكيف|ثلاجة مكيف|كوندنسر|بلف تمدد)/i,
    electrical: /(?:alternator|starter motor|relay|electric motor|electrical accessory|switch|دينمو|سلف|ريليه|محرك كهربائي|سويتش)/i,
    exhaust_body: /(?:exhaust|wiper blade|door handle|exterior part|body accessory|عادم|شكمان|مساحة|مساحات|مقبض|هيكل|قطعة خارجية)/i
  });

  var states = new WeakMap();

  function canonical(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/^sf-part-/, '')
      .replace(/[\s-]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function splitKeys(value) {
    var found = new Set();
    String(value || '').split(/\|\||[|,]/).forEach(function (part) {
      var key = canonical(part);
      if (key) found.add(key);
    });
    return Array.from(found);
  }

  function selectionFromCard(card) {
    if (!card) return null;
    var key = canonical(card.dataset.sfPartsFlatFilter);
    if (!key) return null;
    return {
      key: key,
      label: String(card.dataset.sfPartsFlatLabel || '').trim(),
      leaves: splitKeys(card.dataset.sfPartsFlatLeaves),
      url: String(card.dataset.sfPartsFlatUrl || ''),
      card: card
    };
  }

  function productLeaves(item) {
    var found = new Set();
    String(item.dataset.sfProductTags || item.dataset.fitmentTags || '')
      .split(/\|\||,/)
      .forEach(function (tag) {
        tag = String(tag || '').trim();
        if (!/^sf-part-/i.test(tag)) return;
        var key = canonical(tag);
        if (key) found.add(key);
      });
    [
      item.dataset.sfPartType,
      item.dataset.sfSubcategory,
      item.dataset.sfPartKey
    ].forEach(function (value) {
      splitKeys(value).forEach(function (key) { found.add(key); });
    });
    return Array.from(found);
  }

  function matchesSelection(item, selection) {
    var leaves = productLeaves(item);
    if (leaves.length) {
      return selection.leaves.some(function (key) {
        return leaves.indexOf(key) !== -1;
      });
    }
    var pattern = FALLBACK_PATTERNS[selection.key];
    var text = [
      item.dataset.sfProductInfo,
      item.dataset.sfProductTitle,
      item.dataset.sfPartType,
      item.dataset.sfSubcategory,
      item.dataset.sfPartKey,
      item.textContent
    ].join(' ');
    return Boolean(pattern && pattern.test(text));
  }

  function readTotal(results) {
    var marker = results && results.querySelector('[data-sf-parts-result-total]');
    return Number(marker && marker.dataset.sfPartsResultTotal) || 0;
  }

  function stateFor(browser) {
    if (states.has(browser)) return states.get(browser);
    var results = document.querySelector('[data-sf-spare-parts-results]');
    var state = {
      baseHtml: results ? results.innerHTML : '',
      baseTotal: readTotal(results),
      cache: new Map(),
      controller: null,
      requestId: 0,
      activeKey: '',
      scrollPending: false,
      scrollCancelled: false
    };
    states.set(browser, state);
    return state;
  }

  function isVehicleResultsPath() {
    try {
      var parts = decodeURIComponent(window.location.pathname).split('/').filter(Boolean);
      var collectionIndex = parts.indexOf('collections');
      if (collectionIndex === -1) return false;
      var collectionHandle = parts[collectionIndex + 1] || '';
      var taggedVehicle = parts[collectionIndex + 2] || '';
      return /-(?:esi|esr)\d+$/i.test(collectionHandle) ||
        /-(?:esi|esr)\d+$/i.test(taggedVehicle);
    } catch (_error) {
      return false;
    }
  }

  function isLocalVehicleContext(browser) {
    return browser.classList.contains('is-vin-results-active') ||
      isVehicleResultsPath();
  }

  function finishVehicleChange(browser) {
    if (browser) browser.classList.remove('is-changing-vehicle');
    if (document.body) document.body.classList.remove('sf-parts-changing-vehicle');
    document.documentElement.classList.remove('sf-ymm-results-page');
  }

  function clearlyOutsideSpareParts(item) {
    if (productLeaves(item).length) return false;
    var tags = String(item.dataset.sfProductTags || item.dataset.fitmentTags || '')
      .split('||')
      .map(function (tag) { return String(tag || '').trim(); });
    var departments = tags.filter(function (tag) {
      return /^(?:القسم|department)\s*:/i.test(tag);
    });
    return departments.length > 0 && !departments.some(function (tag) {
      return /(?:قطع\s*غيار|spare\s*parts)/i.test(tag);
    });
  }

  function updateCatalogCounts(total) {
    ['ProductCountDesktop', 'ProductCountMobileSummary'].forEach(function (id) {
      var counter = document.getElementById(id);
      if (!counter) return;
      var text = counter.textContent || '';
      counter.textContent = /\d+/.test(text)
        ? text.replace(/\d+/, String(total))
        : (AR
          ? total + ' منتج متوافق'
          : total + (total === 1 ? ' compatible product' : ' compatible products'));
    });
  }

  function paint(browser, selection, total, loading) {
    browser.querySelectorAll('[data-sf-parts-flat-filter]').forEach(function (card) {
      var candidate = selectionFromCard(card);
      var active = Boolean(selection && candidate && candidate.key === selection.key);
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-pressed', String(active));
      if (active) card.setAttribute('aria-current', 'true');
      else card.removeAttribute('aria-current');
      if (active && loading) card.setAttribute('aria-busy', 'true');
      else card.removeAttribute('aria-busy');
    });

    var feedback = browser.querySelector('[data-sf-flat-feedback]');
    var status = browser.querySelector('[data-sf-flat-status]');
    if (!selection) {
      if (feedback) feedback.hidden = true;
      if (status) status.textContent = '';
      return;
    }

    if (feedback) feedback.hidden = false;
    if (status) {
      status.textContent = loading
        ? (AR ? 'جاري عرض ' + selection.label + '…' : 'Loading ' + selection.label + '…')
        : (AR
          ? selection.label + ' — ' + total + ' منتج'
          : selection.label + ' — ' + total + (total === 1 ? ' product' : ' products'));
    }
  }

  function hydrateImages(browser) {
    browser.querySelectorAll('[data-sf-parts-flat-filter]').forEach(function (card) {
      if (card.dataset.sfFlatImageReady === 'true') return;
      var key = canonical(card.dataset.sfPartsFlatImageKey);
      var url = IMAGE_URLS[key];
      var media = card.querySelector('.sf-flat-parts-card__media');
      if (media && media.querySelector('img')) {
        card.dataset.sfFlatImageReady = 'true';
        card.classList.add('has-curated-category-image');
        return;
      }
      if (!url || !media) return;
      card.dataset.sfFlatImageReady = 'true';
      var image = document.createElement('img');
      image.alt = '';
      image.width = 112;
      image.height = 112;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('load', function () {
        media.replaceChildren(image);
        card.classList.add('has-curated-category-image');
      }, { once: true });
      image.addEventListener('error', function () {
        card.dataset.sfFlatImageReady = 'failed';
      }, { once: true });
      image.src = url;
    });
  }

  function armScroll(state) {
    state.scrollPending = true;
    state.scrollCancelled = false;
  }

  function cancelPendingScroll(state) {
    if (state.scrollPending) state.scrollCancelled = true;
  }

  function scrollOnce(browser, state) {
    if (!state.scrollPending || state.scrollCancelled) {
      state.scrollPending = false;
      return;
    }
    var target = browser.classList.contains('is-vin-results-active')
      ? browser.querySelector('[data-sf-vin-results]')
      : document.querySelector('[data-sf-spare-parts-results]');
    if (!target || target.hidden) {
      state.scrollPending = false;
      return;
    }

    window.requestAnimationFrame(function () {
      if (state.scrollCancelled) {
        state.scrollPending = false;
        return;
      }
      var header = document.querySelector('sticky-header, .header-wrapper, [data-header-sticky]');
      var headerHeight = header ? Math.min(150, header.getBoundingClientRect().height) : 72;
      var top = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 12);
      var root = document.documentElement;
      var previous = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (_error) {}
      window.scrollTo(0, top);
      root.style.scrollBehavior = previous;
      state.scrollPending = false;
    });
  }

  function localFilter(browser, selection, shouldScroll) {
    var state = stateFor(browser);
    var directVin = browser.classList.contains('is-vin-results-active');
    var items = Array.prototype.slice.call(document.querySelectorAll(
      directVin ? '[data-sf-vin-product]' : '[data-sf-spare-parts-product]'
    ));
    if (!items.length) return false;

    var matched = 0;
    items.forEach(function (item) {
      var visible = !clearlyOutsideSpareParts(item) &&
        (!selection || matchesSelection(item, selection));
      item.hidden = !visible;
      item.setAttribute('aria-hidden', String(!visible));
      if (visible) matched += 1;
    });

    state.activeKey = selection ? selection.key : '';
    paint(browser, selection, matched, false);

    if (directVin) {
      var vinGrid = browser.querySelector('[data-sf-vin-products]');
      var vinCount = browser.querySelector('[data-sf-vin-result-count]');
      var vinEmpty = browser.querySelector('[data-sf-vin-empty]');
      if (vinGrid) vinGrid.hidden = matched === 0;
      if (vinEmpty) vinEmpty.hidden = matched > 0 || !selection;
      if (vinCount) {
        vinCount.textContent = AR
          ? matched + ' منتج'
          : matched + (matched === 1 ? ' product' : ' products');
      }
    } else {
      updateCatalogCounts(matched);
      var empty = document.querySelector('[data-sf-parts-local-empty]');
      if (empty) empty.hidden = !selection || matched > 0;
    }

    if (shouldScroll) scrollOnce(browser, state);
    return true;
  }

  function installPayload(browser, state, selection, payload, shouldScroll) {
    var results = document.querySelector('[data-sf-spare-parts-results]');
    if (!results) return false;
    results.innerHTML = payload.html;
    results.hidden = false;
    results.removeAttribute('aria-busy');
    finishVehicleChange(browser);
    results.dataset.sfFlatCatalogView = selection ? selection.key : 'base';
    state.activeKey = selection ? selection.key : '';
    updateCatalogCounts(payload.total);
    paint(browser, selection, payload.total, false);
    if (shouldScroll) scrollOnce(browser, state);
    return true;
  }

  async function fetchPayload(browser, state, selection) {
    if (state.cache.has(selection.key)) return state.cache.get(selection.key);
    var results = document.querySelector('[data-sf-spare-parts-results]');
    var grid = results && results.querySelector('#product-grid');
    var sectionId = grid && grid.dataset.id;
    if (!results || !sectionId || !selection.url) throw new Error('flat catalog source');

    if (state.controller) state.controller.abort();
    state.controller = new AbortController();
    var url = new URL(selection.url, window.location.origin);
    url.hash = '';
    url.searchParams.set('view', 'senfineco-spare-parts');
    url.searchParams.set('section_id', sectionId);
    ['preview_theme_id', '_fd', 'pb'].forEach(function (name) {
      var value = new URL(window.location.href).searchParams.get(name);
      if (value) url.searchParams.set(name, value);
    });

    var response = await fetch(url.toString(), {
      credentials: 'same-origin',
      signal: state.controller.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('flat catalog response ' + response.status);
    var html = await response.text();
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fetched = parsed.querySelector('[data-sf-spare-parts-results]');
    if (!fetched) throw new Error('flat catalog results');
    var payload = { html: fetched.innerHTML, total: readTotal(fetched) };
    state.cache.set(selection.key, payload);
    return payload;
  }

  async function fetchBasePayload(browser, state) {
    var results = document.querySelector('[data-sf-spare-parts-results]');
    var grid = results && results.querySelector('#product-grid');
    var sectionId = grid && grid.dataset.id;
    var source = browser.dataset.sfPartsCatalogUrl || '';
    if (!results || !sectionId || !source) throw new Error('flat base source');

    if (state.controller) state.controller.abort();
    state.controller = new AbortController();
    var url = new URL(source, window.location.origin);
    url.hash = '';
    url.searchParams.set('view', 'senfineco-spare-parts');
    url.searchParams.set('section_id', sectionId);
    ['preview_theme_id', '_fd', 'pb'].forEach(function (name) {
      var value = new URL(window.location.href).searchParams.get(name);
      if (value) url.searchParams.set(name, value);
    });

    var response = await fetch(url.toString(), {
      credentials: 'same-origin',
      signal: state.controller.signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('flat base response ' + response.status);
    var html = await response.text();
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fetched = parsed.querySelector('[data-sf-spare-parts-results]');
    if (!fetched) throw new Error('flat base results');
    return { html: fetched.innerHTML, total: readTotal(fetched) };
  }

  async function refreshBaseAfterVehicleClear(browser) {
    var state = stateFor(browser);
    var results = document.querySelector('[data-sf-spare-parts-results]');
    var requestId = ++state.requestId;
    state.activeKey = '';
    state.scrollPending = false;
    paint(browser, null, 0, false);
    if (results) results.setAttribute('aria-busy', 'true');

    try {
      var payload = await fetchBasePayload(browser, state);
      if (requestId !== state.requestId) return;
      state.baseHtml = payload.html;
      state.baseTotal = payload.total;
      installPayload(browser, state, null, payload, false);
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      if (requestId !== state.requestId) return;
      if (results) {
        results.innerHTML = '';
        results.hidden = true;
        results.removeAttribute('aria-busy');
      }
      finishVehicleChange(browser);
      console.error('[SF Flat Parts] base refresh failed', error);
    }
  }

  async function applySelection(browser, selection) {
    var state = stateFor(browser);
    if (state.activeKey === selection.key) {
      resetCatalog(browser, true);
      return;
    }

    armScroll(state);
    if (isLocalVehicleContext(browser)) {
      localFilter(browser, selection, true);
      return;
    }

    var requestId = ++state.requestId;
    state.activeKey = selection.key;
    paint(browser, selection, 0, true);
    try {
      var payload = await fetchPayload(browser, state, selection);
      if (requestId !== state.requestId) return;
      installPayload(browser, state, selection, payload, true);
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      if (requestId !== state.requestId) return;
      state.scrollPending = false;
      state.activeKey = '';
      paint(browser, null, 0, false);
      var feedback = browser.querySelector('[data-sf-flat-feedback]');
      var status = browser.querySelector('[data-sf-flat-status]');
      if (feedback) feedback.hidden = false;
      if (status) {
        status.textContent = AR
          ? 'تعذّر عرض هذا التصنيف الآن. جرّب مرة أخرى.'
          : 'This category could not be loaded. Please try again.';
      }
      console.error('[SF Flat Parts] category request failed', error);
    }
  }

  function resetCatalog(browser, shouldScroll) {
    var state = stateFor(browser);
    state.requestId += 1;
    if (state.controller) state.controller.abort();
    armScroll(state);

    if (isLocalVehicleContext(browser)) {
      localFilter(browser, null, shouldScroll);
      return;
    }

    var payload = { html: state.baseHtml, total: state.baseTotal };
    installPayload(browser, state, null, payload, shouldScroll);
  }

  function bindCancellation(browser, state) {
    if (browser.dataset.sfFlatScrollCancelReady === 'true') return;
    browser.dataset.sfFlatScrollCancelReady = 'true';
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (type) {
      document.addEventListener(type, function () {
        cancelPendingScroll(state);
      }, { capture: true, passive: type !== 'keydown' });
    });
  }

  function init(browser) {
    if (!browser ||
        browser.dataset.sfPartsCatalogMode !== 'spare_parts' ||
        !browser.querySelector('[data-sf-parts-flat-filter]')) return;

    var state = stateFor(browser);
    hydrateImages(browser);
    bindCancellation(browser, state);
    if (browser.dataset.sfFlatPartsReady === 'true') return;
    browser.dataset.sfFlatPartsReady = 'true';
    if (isLocalVehicleContext(browser)) localFilter(browser, null, false);

    browser.addEventListener('click', function (event) {
      var card = event.target.closest('[data-sf-parts-flat-filter]');
      if (card && browser.contains(card)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var selection = selectionFromCard(card);
        if (selection) applySelection(browser, selection);
        return;
      }

      var reset = event.target.closest('[data-sf-flat-reset]');
      if (reset && browser.contains(reset)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        resetCatalog(browser, true);
      }
    }, true);
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('[data-sf-spare-parts-browser]')) init(context);
    context.querySelectorAll('[data-sf-spare-parts-browser]').forEach(init);
  }

  boot(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('sf:parts-vehicle-change', function (event) {
    document.querySelectorAll('[data-sf-spare-parts-browser]').forEach(function (browser) {
      if (!browser.querySelector('[data-sf-parts-flat-filter]')) return;
      var state = stateFor(browser);
      state.requestId += 1;
      if (state.controller) state.controller.abort();
      state.scrollPending = false;
      if (!event.detail) {
        document.documentElement.classList.remove('sf-ymm-results-page');
        refreshBaseAfterVehicleClear(browser);
        return;
      }
      localFilter(browser, null, false);
    });
  });
})();
